import {
  Component,
  forwardRef,
  Inject,
  Input
}                             from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { InvoiceModel }       from '../invoices/models/invoice';
import { NgbActiveModal }     from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }   from '@ngx-translate/core';

import { MessagesService } from '../messages/messages.service';
import { StripeService }   from './stripe.service';

@Component({
  selector   : 'wor-stripe-checkout',
  template: require('./stripe.checkout.component.html')
})
export class StripeCheckoutComponent {
  public accountId : string = this.stripeService.getAccountId();
  public publicKey : string = this.stripeService.getPublicKey();

  @BlockUI('stripeCheckoutBlock') block : NgBlockUI;

  @Input() invoice : InvoiceModel;

  constructor (
    public  activeModal     : NgbActiveModal,
    private messagesService : MessagesService,
    @Inject(forwardRef(() => StripeService))
    private stripeService   : StripeService,
    private translateService: TranslateService
  ) {}

  handlePaymentError ( error : stripe.Error ) : void {
    this.block.stop();

    this.messagesService.error(error.message);
  }

  handlePaymentSuccess ( intent : stripe.paymentIntents.PaymentIntent ) : void {
    this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.PAYMENT_SUCCESSFUL'), 'success');

    this.activeModal.close(intent);
  }

  submit () : void {
    this.block.start(this.translateService.instant('GENERAL_SPACE.MESSAGE.SENDING'));

    window['collectStripePayment']();
  }
}
